import { render, staticRenderFns } from "./ConsultaTitulos.vue?vue&type=template&id=cb245b4a"
import script from "./ConsultaTitulos.vue?vue&type=script&lang=js"
export * from "./ConsultaTitulos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dartanghanvani/Documents/workspace/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb245b4a')) {
      api.createRecord('cb245b4a', component.options)
    } else {
      api.reload('cb245b4a', component.options)
    }
    module.hot.accept("./ConsultaTitulos.vue?vue&type=template&id=cb245b4a", function () {
      api.rerender('cb245b4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ConsultaTitulos.vue"
export default component.exports